import { useMutation } from "react-query";
import axios, { AxiosError, AxiosResponse } from "axios";
import { toast } from "react-toastify";
import { plantDockUrls } from "../../URL/ApplicationUrls";
import { MdmApiError } from "../../Errors/MdmApiError";
import { apiErrorNotificationToast } from "../../Errors/apiErrorNotificationToast";
import { PlantDock } from "../PlantDock";
import { addSuccessMessage } from "../../Messages/successMessages";

export const useAddDock = () => {
  return useMutation({
    mutationFn: (dock: PlantDock) => {
      return axios.post<PlantDock>(plantDockUrls.docksForPlantWithId(dock.PlantId), dock);
    },
    onSuccess: async (response: AxiosResponse<PlantDock>) => {
      toast.success(addSuccessMessage(response.data.Id, "Dock"));
    },
    onError: (error: AxiosError<MdmApiError>) => {
      apiErrorNotificationToast(error);
    },
  });
};
